import utils from '@/utils';
export default {
  install: function install(Vue) {
    Vue.prototype.$open = utils.open;
  }
};